// extracted by mini-css-extract-plugin
module.exports = {"BrownSpiralBullets":"brownSpiral_BrownSpiralBullets__ltbE_"};